import React from "react";

const LogoRus = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="190px"
      height="40"
      viewBox="0 0 388 48.2"
      {...props}
    >
      <defs>
        <style>
          {/* .cls-1 {
                        stroke-width: 0px;
                    } */}
        </style>
      </defs>
      <polygon
        className="cls-1"
        points="112.34 7.93 107.56 7.93 100.5 16.34 98.71 16.34 98.71 7.93 94.09 7.93 94.09 28.78 98.71 28.78 98.71 19.76 100.5 19.76 106.96 28.78 112.45 28.78 104.25 17.59 112.34 7.93"
      />
      <path
        className="cls-1"
        d="m81.77,7.38c-6.08,0-10.37,4.72-10.37,10.97,0,6.84,4.67,10.97,11.18,10.97,3.47,0,5.7-.81,7.17-2.01v-3.47c-1.3.98-3.31,1.74-5.97,1.74-4.18,0-6.73-2.23-7.33-5.81h14.23c.11-.71.22-1.47.22-2.82,0-5.48-3.37-9.56-9.12-9.56Zm-5.38,8.96c.27-3.09,2.39-5.38,5.1-5.38s4.51,1.95,4.62,5.38h-9.72Z"
      />
      <polygon
        className="cls-1"
        points="332.29 9.56 328.11 9.56 328.11 16.4 321.32 16.4 321.32 19.82 328.11 19.82 328.11 27.15 332.29 27.15 332.29 19.82 338.97 19.82 338.97 16.4 332.29 16.4 332.29 9.56"
      />
      <path
        className="cls-1"
        d="m58.53,7.38c-6.24,0-10.42,4.24-10.42,10.97s4.18,10.97,10.42,10.97,10.42-4.24,10.42-10.97-4.18-10.97-10.42-10.97Zm0,18.35c-3.58,0-5.59-2.88-5.59-7.38s2.01-7.38,5.59-7.38,5.59,2.88,5.59,7.38-2.01,7.38-5.59,7.38Z"
      />
      <path
        className="cls-1"
        d="m36.6,7.38c-2.5,0-4.78,1.09-6.46,2.5v-1.95h-4.62v30.08h4.62v-11.18c1.68,1.41,3.96,2.5,6.46,2.5,5.32,0,9.07-4.02,9.07-10.97s-3.75-10.97-9.07-10.97Zm-1.19,18.35c-2.17,0-3.69-.65-5.27-1.9v-10.91c1.57-1.3,3.09-1.95,5.27-1.95,3.15,0,5.43,2.17,5.43,7.38s-2.28,7.38-5.43,7.38Z"
      />
      <polygon
        className="cls-1"
        points="0 28.78 4.94 28.78 4.94 3.69 16.4 3.69 16.4 28.78 21.39 28.78 21.39 0 0 0 0 28.78"
      />
      <polygon
        className="cls-1"
        points="113.48 11.35 119.67 11.35 119.67 28.78 124.28 28.78 124.28 11.35 130.47 11.35 130.47 7.93 113.48 7.93 113.48 11.35"
      />
      <polygon
        className="cls-1"
        points="338.97 0 338.97 3.69 343.74 3.69 343.74 28.78 348.74 28.78 348.74 0 338.97 0"
      />
      <polygon
        className="cls-1"
        points="243.41 11.35 249.6 11.35 249.6 28.78 254.21 28.78 254.21 11.35 260.4 11.35 260.4 7.93 243.41 7.93 243.41 11.35"
      />
      <path
        className="cls-1"
        d="m192.53,7.38c-2.5,0-4.78,1.09-6.46,2.5v-1.95h-4.62v30.08h4.62v-11.18c1.68,1.41,3.96,2.5,6.46,2.5,5.32,0,9.07-4.02,9.07-10.97s-3.75-10.97-9.07-10.97Zm-1.19,18.35c-2.17,0-3.69-.65-5.27-1.9v-10.91c1.57-1.3,3.09-1.95,5.27-1.95,3.15,0,5.43,2.17,5.43,7.38s-2.28,7.38-5.43,7.38Z"
      />
      <polygon
        className="cls-1"
        points="268.11 22.42 268.11 7.93 263.5 7.93 263.5 28.78 268.11 28.78 277.29 14.28 277.29 28.78 281.9 28.78 281.9 7.93 277.29 7.93 268.11 22.42"
      />
      <polygon
        className="cls-1"
        points="222.99 7.93 218.16 7.93 211.1 16.34 209.31 16.34 209.31 7.93 204.69 7.93 204.69 28.78 209.31 28.78 209.31 19.76 211.1 19.76 217.62 28.78 223.05 28.78 214.9 17.59 222.99 7.93"
      />
      <polygon
        className="cls-1"
        points="144.7 20.47 138.18 7.93 133.51 7.93 133.51 28.78 138.18 28.78 138.18 15.8 143.01 25.08 146.43 25.08 151.1 15.85 151.1 28.78 155.77 28.78 155.77 7.93 151.1 7.93 144.7 20.47"
      />
      <path
        className="cls-1"
        d="m233.04,7.38c-6.08,0-10.37,4.72-10.37,10.97,0,6.84,4.67,10.97,11.18,10.97,3.47,0,5.7-.81,7.17-2.01v-3.47c-1.3.98-3.31,1.74-5.97,1.74-4.18,0-6.73-2.23-7.33-5.81h14.23c.11-.71.22-1.47.22-2.82,0-5.48-3.37-9.56-9.12-9.56Zm-5.38,8.96c.27-3.09,2.39-5.38,5.1-5.38s4.51,1.95,4.62,5.38h-9.72Z"
      />
      <polygon
        className="cls-1"
        points="299.44 16.4 290.81 16.4 290.81 7.93 286.19 7.93 286.19 28.78 290.81 28.78 290.81 19.76 299.44 19.76 299.44 28.78 304.05 28.78 304.05 7.93 299.44 7.93 299.44 16.4"
      />
      <polygon
        className="cls-1"
        points="321.75 7.93 308.34 7.93 308.34 28.78 312.96 28.78 312.96 11.35 321.75 11.35 321.75 7.93"
      />
      <path
        className="cls-1"
        d="m167.72,7.44c-4.45,0-6.95,1.63-6.95,1.63v3.85s2.55-1.9,6.08-1.9c3.31,0,5.1,1.41,5.76,3.75l-6.24.92c-4.62.71-7.49,3.53-7.49,7.06,0,3.96,2.66,6.62,7.06,6.62,3.15,0,5.54-1.52,6.95-2.82v2.28h4.62v-12.11c0-5.38-3.26-9.28-9.77-9.28Zm5.16,16.23c-1.36.98-3.53,2.28-5.7,2.28-2.39,0-3.53-1.14-3.53-3.09,0-2.06,1.41-3.37,4.29-3.96l4.94-1.03v5.81Z"
      />
    </svg>
  );
};

export default LogoRus;
